import React, { createContext, useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const SearchContext = createContext(null);

export const SearchProvider = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState("");
  // useEffect(() => {
  //   const q = searchParams.get("search_query") || "";
  //   setQueryState(q);
  // }, [searchParams]);
  // const setQuery = (value) => {
  //   setQueryState(value);
  //   const params = new URLSearchParams(searchParams);
  //   if (value) params.set("search_query", value);
  //   else params.delete("search_query");
  //   setSearchParams(params);
  // };

  return (
    <SearchContext.Provider value={{ query, setQuery }}>
      {children}
    </SearchContext.Provider>
  );
};

// hook
export const useSearch = () => useContext(SearchContext);
